import Vue from 'vue'
import IdleVue from 'idle-vue'

Vue.use(IdleVue, {
  eventEmitter: new Vue(),
  idleTime: process.env.VUE_APP_IDLE_TIMEOUT_WARNING,
})
